import { getToken } from '@/utils/bridge';
import VConsole from 'vconsole';
import defaultSettings from '../defaultSettings';

// @ts-ignore
const { aplus_queue } = window;
aplus_queue.push({
  action: 'aplus.setMetaInfo',
  arguments: ['aplus-waiting', 'MAN'],
});

//是否开启调试模式
aplus_queue.push({
  action: 'aplus.setMetaInfo',
  arguments: [
    'DEBUG',
    defaultSettings.projectName !== 'qf-react-app-online' &&
      defaultSettings.projectName !== 'react-web-local',
  ],
});

/************************以下内容为可选配置内容****************************/
//sdk提供手动pv发送机制，启用手动pv(即关闭自动pv)，需设置aplus-waiting=MAN;
//注意：由于单页面路由改变时不会刷新页面，无法自动发送pv，所以对于单页应用，强烈建议您关闭自动PV, 手动控制PV事件

//是否指定用作计算umid的id类型，默认为cnaid，目前支持:
//1. 微信和QQ: openid; 字节和百度 anonymousid; 支付宝 alipay_id
//2. 微信、QQ、字节、百度平台的 unionid
//3. 业务方自己生成的随机id uuid
// aplus_queue.push({
//   action: 'aplus.setMetaInfo',
//   arguments: ['aplus-idtype', 'xxxx'] //取值参考见附表1
// });

// aplus_queue.push({
//   action: 'aplus.record',
//   arguments: ['yourTrackerEventCode', 'CLK', {
//     param1: '111',
//     param2: '222',
//     param3: 333
//   }]
// });

/******************************************************************/

// @ts-ignore
export function onRouteChange(data) {
  const { location, matchedRoutes } = data;
  if (matchedRoutes.length > 2) {
    const {
      match: { path },
      route,
    } = matchedRoutes[2];
    let title = route?.title;
    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [
        {
          is_auto: false,
        },
        {
          page_name: path,
          title: title,
        },
      ],
    });
  }

  if (
    location.pathname.indexOf('/agreement/PrivilegePrivacy') === -1 &&
    location.pathname.indexOf('/agreement/PrivacyClause') === -1 &&
    location.pathname.indexOf('/agreement/ThirdParty') === -1 &&
    location.pathname.indexOf('/agreement/Information') === -1
  ) {
    getToken(false);
  }
}

if (
  defaultSettings.projectName !== 'qf-react-app-online' &&
  defaultSettings.projectName !== 'qf-react-app-local'
) {
  new VConsole();
}
